'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isInView(element) {
  if (document.visibilityState === 'hidden') {
    return false;
  }
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  var rect = element.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0 && !(rect.top > viewportHeight || rect.bottom < 0);
}

function createElement(tpl) {
  var el = document.createElement('div');
  // remove spaces between tags to avoid unwanted margins
  el.innerHTML = String(tpl).replace(/>\s+</g, '><');
  return el.firstElementChild;
}

function once(element, event, func) {
  var isExeced = false;
  element.addEventListener(event, function () {
    if (isExeced) {
      element.removeEventListener(event, func);
      return;
    }
    func();
    isExeced = true;
  }, { once: true });
}

function hasClassName(element, name) {
  return element.className.indexOf(name) >= 0;
}
function removeClassName(element, name) {
  element.className = element.className.replace(name, '').trim();
}
function addClassName(element, name) {
  if (hasClassName(element, name)) {
    return;
  }
  element.className = element.className + ' ' + name;
}

function getElWidth(container, width) {
  if (Number(width)) {
    return width;
  }
  if (!container || !container.clientWidth) {
    return null;
  }
  return container.clientWidth * parseInt(width, 10) / 100;
}

exports.isInView = isInView;
exports.createElement = createElement;
exports.once = once;
exports.hasClassName = hasClassName;
exports.removeClassName = removeClassName;
exports.addClassName = addClassName;
exports.getElWidth = getElWidth;